import React, { useEffect } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import DescriptionIcon from "@material-ui/icons/Description";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import teal from "@material-ui/core/colors/teal";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _PoliciesListTable } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form/";
import { DeleteEmptyParams } from "../helpers/Common";
import useTable from "../../inar2/hooks/Table";

interface IRouteParam {
    ID_TipoRamo?: string;
    ID_Anag?: string;
}

export const _PoliciesList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag = "" } = useParams<IRouteParam>();
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({
        Polizza: "",
        ContraenteCoobbligatoAti:"",
        ID_TipoRamo: "",
        ID_TipoProdotto: "",
        ID_TipoPolizzaStato: "",
        ID_AnagContraente: ID_Anag,
        ID_AnagPOS: "",
        ID_AnagBeneficiario: "",
        ID_TipiRicercaDate: "",
        ID_AnagCoobbligato: "",
        DataDa: "",
        DataA: "",
        IsAll: "0"
    });
    const { Data, Options, IsLoading } = useTable("/api/Polizza/RicercaGenerale", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("PolizzaController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Home", ID_MenuMain: (props.match.params as any).ID_Anag ? 10 : 8 });
    }, []);

    useEffect(() => {
        setFormData({ Type: "OnChangeFromValue", Name: "ID_TipoProdotto", Value: "" });
    }, [FormData.ID_TipoRamo]);

    useEffect(() => {
        setFormData({ Type: "Set", Value: { ...FormData, DataDa: "", DataA: "" } });
    }, [FormData.ID_TipiRicercaDate]);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={DescriptionIcon} Title="PolizzePreventivi">
                    {Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura) && (
                        <a href={`/api/Polizza/EsportaEXCELSimple?sessione=${Glob.GetSessione().Sessione}&parametri=${JSON.stringify(DeleteEmptyParams({ ...FormData }))}`} target="_blank">
                            <Tooltip title="Excel semplificato">
                                <IconButton size="small" aria-label="add">
                                    <InsertDriveFileIcon htmlColor={teal[200]} />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                    {Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura) && (
                        <a href={`/api/Polizza/EsportaEXCEL?sessione=${Glob.GetSessione().Sessione}&parametri=${JSON.stringify(DeleteEmptyParams({ ...FormData }))}`} target="_blank">
                            <Tooltip title="Excel">
                                <IconButton size="small" aria-label="add">
                                    <InsertDriveFileIcon htmlColor={teal[400]} />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                    <span>  </span>
                    {Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura) && (
                        <a href={`/api/Polizza/EsportaEXCEL?sessione=${Glob.GetSessione().Sessione}&parametri=${JSON.stringify(DeleteEmptyParams({ ...FormData, IsAll: "1"}))}`} target="_blank">
                            <Tooltip title="Excel tutti appendici">
                                <IconButton size="small" aria-label="add">
                                    <InsertDriveFileIcon htmlColor={teal[800]} />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={6} md={2}>
                                <TextField
                                    fullWidth
                                    id="Polizza"
                                    label={Trad.Trad("Numero")}
                                    value={FormData.Polizza}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoRamo}
                                    Name="ID_TipoRamo"
                                    Label="Ramo"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Tipi/Tipo?tabella=TipiRami&campo=TipoRamo"
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoProdotto}
                                    Name="ID_TipoProdotto"
                                    Label="Prodotto"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url={`/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto&parametri=${FormData.ID_TipoRamo}`}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_Select
                                    Value={FormData.ID_TipiRicercaDate || ""}
                                    Name="ID_TipiRicercaDate"
                                    Label="Data"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["TipiRicercaDate"]) || {}}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_DateField Value={FormData.DataDa || ""} Name="DataDa" Label="Da" OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_DateField Value={FormData.DataA || ""} Name="DataA" Label="A" OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Select
                                    Value={FormData.ID_TipoPolizzaStato || ""}
                                    Name="ID_TipoPolizzaStato"
                                    Label="Stato"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["PolizzaStato"]) || {}}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagContraente}
                                    Name="ID_AnagContraente"
                                    Label="Contraente"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagPOS}
                                    Name="ID_AnagPOS"
                                    Label="POS"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagBeneficiario}
                                    Name="ID_AnagBeneficiario"
                                    Label="Beneficiario"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagCoobbligato}
                                    Name="ID_AnagCoobbligato"
                                    Label="Contraente/Coobbligato"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    id="ContraenteCoobbligatoAti"
                                    label={Trad.Trad("Contraente/Coobbligato/Ati")}
                                    value={FormData.ContraenteCoobbligatoAti}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_PoliciesListTable Data={Data} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/PoliciesList.tsx